import { render, staticRenderFns } from "./BetgameFAQ.vue?vue&type=template&id=0e40c65e&scoped=true"
import script from "./BetgameFAQ.vue?vue&type=script&lang=js"
export * from "./BetgameFAQ.vue?vue&type=script&lang=js"
import style0 from "./BetgameFAQ.vue?vue&type=style&index=0&id=0e40c65e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e40c65e",
  null
  
)

export default component.exports